import { FC, useMemo, useRef } from "react"
import { Control, Controller } from "react-hook-form";
import { DiaryFiltersFormValues } from "shared/types";
import { DiaryFiltersItem, DiaryFiltersItemTitle, DiaryFiltersRangeItemBody, DiaryFiltersRangeItemFooter } from "./styles";
import Input from '@atomaro/ui-kit/components/Input/Input';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';

type TFieldNames = Pick<DiaryFiltersFormValues, 'framesFrom' | 'framesTo' | 'broodFrom' | 'broodTo' | 'strengthFrom' | 'strengthTo'>

type DiaryFiltersRangeItemProps = {
  name: string;
  control: Control<DiaryFiltersFormValues, any, DiaryFiltersFormValues>;
  fieldNames: {
    from: keyof TFieldNames;
    to: keyof TFieldNames;
  },
  showReset: boolean;
  showFooter?: boolean;
  hideHeader?: boolean;
  onChange: (name: keyof DiaryFiltersFormValues, value: string) => void;
  onReset: (names: (keyof DiaryFiltersFormValues)[]) => void;
  onSubmitClick?: () => void;
  onCancelClick?: () => void;
}

export const DiaryFiltersRangeItem: FC<DiaryFiltersRangeItemProps> = ({
  name,
  control,
  fieldNames,
  showReset,
  showFooter,
  hideHeader,
  onChange,
  onReset,
  onSubmitClick,
  onCancelClick,
}) => {
  const node = useRef(null);

  const visibleName = useMemo(() => {
    let str = ''
    switch (name) {
      case 'frames':
        str = 'Рамки'
        break;
      case 'strength':
        str = 'Сила'
        break;
      case 'brood':
        str = 'Расплод'
        break;
    
      default:
        break;
    }

    return str;
  }, [name])
  
  return (
    <DiaryFiltersItem ref={node}>
      {!hideHeader && 
      <DiaryFiltersItemTitle>
        <span>{visibleName}</span>
        {showReset && <button onClick={() => onReset([fieldNames.from, fieldNames.to])}>Сбросить</button>}
      </DiaryFiltersItemTitle>
      }
      <DiaryFiltersRangeItemBody>
        <Controller 
          control={control}
          name={fieldNames.from}
          rules={{pattern: /\d/g}}
          render={({field}) => (
            <Input 
              name={field.name}
              value={field.value}
              label="От"
              onChange={(event) => onChange(field.name, event.target.value)}
              inputMode="numeric"
              onFocus={event => event.target.select()}
            />
          )}
        />
        <Controller 
          control={control}
          name={fieldNames.to}
          rules={{pattern: /\d/g}}
          render={({field}) => (
            <Input 
              name={field.name}
              value={field.value}
              label="До"
              onChange={(event) => onChange(field.name, event.target.value)}
              inputMode="numeric"
              onFocus={event => event.target.select()}
            />
          )}
        />
      </DiaryFiltersRangeItemBody>
      {showFooter && 
      <DiaryFiltersRangeItemFooter>
          <Button 
            label="Отменить"
            variant="ghost"
            colorScheme="neutral"
            onClick={onCancelClick}
          />
          <Button 
            label="Применить"
            onClick={onSubmitClick}
          />
      </DiaryFiltersRangeItemFooter>
      }
    </DiaryFiltersItem>
  )
}